var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-cart"},[_c('a',{attrs:{"href":"/butik/varukorg"}},[_c('button',{staticClass:"btn addtocart",attrs:{"type":"button"}},[_vm._v("Varukorg ( "+_vm._s(_vm.cart.items.length)+" produkter )")])])])}
var staticRenderFns = []

export { render, staticRenderFns }